export const coupon = {
    title: "Discount",
    all_coupon: "All Coupon",
    my_coupon: "My Coupon",
    use_now: "Use Now",
    use: "Use",
    Used: "Used",
    crown_point: "Crowns",
    warning_point_not_enough: "You have insufficient crowns. Earn {0} crowns to redeem this coupon.",
    expire: "Expire : ",
    discount: "Coupon Discount",
    bath: "Baht",
    promocode: {
        name: 'Enter promo code',
        placeholder: 'Enter promo code',
        required: 'Please enter promo code',
        too_short: '',
        invalid: '',
    },
    popup_confirm: {
        coupon: "Coupon : ",
        line2: "Your Crowns will be deducted<br>immediately after confirmation",
        line3: '"if not use immediately coupons will be stared at "My Coupon"',
        confirm: 'Confirm'
    },
    condition: 'condition',
    popup_condition: {
        coupon: 'Coupon',
        condition: 'condition'
    }
};